<!-- Preview Controls (shown when document is selected) -->
<div *ngIf="document && !isLoading" class="preview-controls mb-3">
	<div class="flex justify-content-between align-items-center">
		<div class="font-semibold text-overflow-ellipsis overflow-hidden white-space-nowrap" style="max-width: 60%">
			{{ document.fileName }}
		</div>
		<div class="flex gap-2">
			<p-button
				icon="pi pi-minus"
				[text]="true"
				[rounded]="true"
				(onClick)="onZoomOut()"
				[disabled]="zoomLevel <= 0.5"
				pTooltip="Zoom Out"
				tooltipPosition="top"
			/>
			<span class="flex align-items-center px-2">{{ getZoomPercentage() }}%</span>
			<p-button
				icon="pi pi-plus"
				[text]="true"
				[rounded]="true"
				(onClick)="onZoomIn()"
				[disabled]="zoomLevel >= 2.0"
				pTooltip="Zoom In"
				tooltipPosition="top"
			/>
			<p-button
				icon="pi pi-download"
				label="Download"
				[outlined]="true"
				(onClick)="onDownload()"
				pTooltip="Download Document"
				tooltipPosition="top"
			/>
			<p-button
				*ngIf="showDelete"
				icon="pi pi-trash"
				[outlined]="true"
				severity="danger"
				[loading]="isDeleting"
				[disabled]="isDeleting"
				(onClick)="onRemove()"
				pTooltip="Delete Image"
				tooltipPosition="top"
			/>
		</div>
	</div>
</div>

<!-- Loading State -->
<div *ngIf="isLoading" class="preview-empty">
	<p-progressSpinner styleClass="w-3rem h-3rem" />
	<p class="text-color-secondary mt-3">Loading preview...</p>
</div>

<!-- Empty State -->
<div *ngIf="!document && !isLoading" class="preview-empty">
	<i class="pi pi-file text-6xl text-color-secondary mb-3"></i>
	<p class="text-color-secondary">Select a document to preview</p>
</div>

<!-- Preview Content -->
<div *ngIf="document && !isLoading && previewUrl" class="preview-content">
	<!-- PDF Preview: ng2-pdf-viewer is created here on demand (DOVE-2520, see mountPdfViewer) -->
	<ng-container *ngIf="document.isPdf">
		<p-message
			*ngIf="pdfLoadFailed"
			severity="error"
			text="The preview couldn't be loaded. Please reload the page and try again."
			styleClass="w-full"
		/>
		<ng-template #pdfHost></ng-template>
	</ng-container>

	<!-- Image Preview -->
	<div *ngIf="document.isImage" class="image-preview">
		<img [src]="previewUrl" [alt]="document.fileName" [style.transform]="'scale(' + zoomLevel + ')'" />
	</div>

	<!-- Other File Types - Show message -->
	<div *ngIf="!document.isPdf && !document.isImage" class="preview-empty">
		<i class="pi pi-file text-6xl text-color-secondary mb-3"></i>
		<p class="text-color-secondary">Preview not available for this file type</p>
		<p class="text-sm text-color-secondary mt-2">Use the Download button to view the file</p>
	</div>
</div>

<!-- No preview URL state -->
<div *ngIf="document && !isLoading && !previewUrl" class="preview-empty">
	<i class="pi pi-exclamation-triangle text-6xl text-color-secondary mb-3"></i>
	<p class="text-color-secondary">Preview not available</p>
	<p class="text-sm text-color-secondary mt-2">Use the Download button to view the file</p>
</div>
